import { Route, Routes, useNavigate } from "react-router-dom";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

import "../src/Components/App.css";
import Login from "./Components/Layout/Login";
import Main from "./Components/Layout/Main";
import { useCallback, useEffect,useRef } from "react";

function App() {
  const hasSessionId = !!sessionStorage.getItem("sessionId");
  const navigate = useNavigate();
  const logoutTimerRef = useRef(null);

 

  const logout = useCallback(() => {
    sessionStorage.removeItem("sessionId");
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    if (!hasSessionId) {
      navigate("/");
      return;
    }

    const startTimer = () => {
      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
      }
      logoutTimerRef.current = setTimeout(() => {
        logout();
      }, 3600000); // 1 hour
    };

    // Start initial timer
    startTimer();

    // Reset timer on user activity
    const resetTimer = () => {
      startTimer();
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);

    return () => {
      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
      }
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
    };
  }, [hasSessionId, navigate, logout]);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/main/*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default App;
